<div class="page" [ngClass]="{'app-light-theme': !themeService.isDark, 'app-dark-theme': themeService.isDark}">
	<main id="maincontent" tabindex="-1" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
		<div class="banner" fxLayoutAlign="center center" fxLayout="column" fxLayoutGap="12px">
			<img class="logo" fxHide.gt-md src="assets/img/open_sims_logo_sm.svg" alt="{{'Common.ImageDescriptions.OpenSIMSLogo' | translate}}">
			<img class="logo" fxHide.lt-lg src="assets/img/open_sims_logo_md.svg" alt="{{'Common.ImageDescriptions.OpenSIMSLogo' | translate}}">
			<h1 role="alert">{{'Session.Expired.Title' | translate}}</h1>
		</div>
		<p>{{'Session.Expired.Message' | translate}}</p>
		<p class="close-browser">{{'Session.Expired.CloseBrowser' | translate}}</p>
		<a mat-flat-button color="primary" [routerLink]="['/sign-in']">{{'Session.Expired.SignInAgain' | translate}}</a>
	</main>
</div>
